import React, { useEffect } from "react";
import { Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { getEmployee } from "../redux/employees/actions";
import "../../src/css/capacitacion.css";

const UserHeadDetailMenu = (props) => {
  const userRoles = useSelector((store) => store.auth.userRoles);
  const username = useSelector((store) => store.auth.username);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEmployee(props.id, parseInt(props.type)));
  }, []);
  return (
    <Nav className="user-head-menu" variant="pills">
      <Nav.Item>
        <NavLink
          className="nav-link"
          to={`/detalle-empleado/${props.id}/${props.type}`}
        >
          Info
        </NavLink>
      </Nav.Item>
      <Nav.Item>
        <NavLink
          className="nav-link"
          to={`/ficha-empleado/${props.id}/${props.type}`}
        >
          Ficha
        </NavLink>
      </Nav.Item>
      <Nav.Item>
        <NavLink
          className="nav-link"
          to={`/empleado-tiempos/${props.id}/${props.type}`}
        >
          Tiempos
        </NavLink>
      </Nav.Item>
      <Nav.Item>
        <NavLink
          className="nav-link"
          to={`/capacitacion/${props.id}/${props.type}`}
        >
          Inducción
        </NavLink>
      </Nav.Item>
      <Nav.Item>
        <NavLink
          className="nav-link"
          to={`/clima-laboral/encuestas-pendientes/${props.id}/${props.type}`}
        >
          Clima
        </NavLink>
      </Nav.Item>
      <Nav.Item>
        {/* <Nav.Link href="" style={{'opacity':'0.5'}} disabled>Docs</Nav.Link> */}
        <NavLink
          className="nav-link"
          to={`/activos-fijos/${props.id}/${props.type}`}
        >
          Activos
        </NavLink>
      </Nav.Item>
      {/* {userRoles.length > 0 &&
        (userRoles.includes("empleado") || userRoles.includes("jefe")) && ( */}
      <Nav.Item>
        <NavLink
          className="nav-link"
          to={`/historial/${props.id}/${props.type}`}
        >
          Historial
        </NavLink>
      </Nav.Item>
      <Nav.Item>
        <NavLink
          className="nav-link"
          to={`/evaluaciones/${props.id}/${props.type}`}
        >
          Evaluaciones
        </NavLink>
      </Nav.Item>
      {/* )} */}
      <Nav.Item>
        {/*<Nav.Link href="" style={{'opacity':'0.5'}} disabled>Docs</Nav.Link>*/}
        <NavLink
          className="nav-link"
          to={`/empleado-docs/${props.id}/${props.type}`}
        >
          docs
        </NavLink>
      </Nav.Item>
      <Nav.Item>
        <NavLink
          className="nav-link"
          to={`/usuario-documentos/${props.id}/${props.type}`}
        >
          Check List
        </NavLink>
      </Nav.Item>
      <Nav.Item>
        <NavLink
          className="nav-link"
          to={`/solicitud-vacaciones-empleado/${username}`}
        >
          Solicitud Vacaciones
        </NavLink>
      </Nav.Item>
    </Nav>
  );
};

export default UserHeadDetailMenu;